import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";

import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  ExpandIcon,
  NewBackButton,
  Phone,
  RightArrow,
  Time as TimeIcon,
  VoiceIcon,
  CollapseIcon,
} from "../../../components/svgs";
import {
  Body,
  Children,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";
import { BackButton, FeatureHeader } from "../../../components/common";

const terms = [
  { text: "The promo targets only MTN Smartphone customers within the Youth Segment." },

  { text: "Promo participation is limited to only user who download myMTN App and perform mashup activities. " },

  { text: "As a digital oriented promo, there will be no opt in by way of USSD channel.All Smartphone customers on MTN within the Youth Segment qualify to participate in the promo." },

  { text: "The minimum spend to accrue promo point is one pesewa and above." },

  { text: "Customers points target will be done once at the commencement of the promo and will remain the same during the duration of the promo." },

  { text: "All promo participants will enjoy a one off 50, 000 start - up cushioning points." },

  { text: "Participants enjoy the 50, 000 once.Therefore, all myMTN App installations after uninstallations will not attract additional 50, 000 start up points." },

  { text: "All MTN customers who mashup on myMTN App will be captured and classified as Group B and will be ranked separately at the end of each month." },

  { text: "Monthly prize rewards will be based on the percentage margin at which participants exceed their target points ranked from the highest percentage margin to the lowest." },
  { text: "Usage on mashups / Airtime does not accrue points.This is because payment is made at the time of purchase on myMTN App and points are awarded at purchase stage and not usage stage." },

  { text: "If a Smartphone customer buys any bundle package / Airtime(mashup for others) on myMTN App for any SIM or device, the Smartphone customer that buys the package earns the relevant points.Recipients of gift packages do not accrue points. " },

  { text: "All purchases including MoMo transactions done on myMTN App while roaming will accrue points." },

  { text: "Promo participants can check their points on the Pulse Homescreen on myMTN App at any time of the day." },

  { text: "Points displayed on MTN Pulse on myMTN App give participants a fair idea as to how they are performing in the promo and cannot be deemed as the very final points accrued.Final points are determined by actual network activities on the App available on Customer Data Records(CDR) indicating every spend and mashup transaction on myMTN App." },

  { text: "In case there are challenges on the accumulator, manual computation of points using CDR will be used for winner selection and rankings." },

  { text: "Customer gains points based on mashup.Thus, customer accrues 5 points for every pesewa spend to purchase mashup on myMTN App. " },

  {
    text: "For simplicity and ease of reference, below captures the promo points accrual rules:",
    table: {
      title: 'Points Accrual Template',
      rows: [
        ['One off Start-Up points', '50,000 pts after successful app download'],
        ['Points accrued via Mashup activities on myMTN', 'App 1 Pesewa = 5points'],
      ]
    }
  },

  { text: "Points accrued will have no bearing on the ensuing month in the case of monthly winner rankings.Participants will have to do fresh network activities on myMTN App to accrue points during the new month. " },

  { text: "SIMs dedicated solely for commercial transactions by Mobile Money merchants are exempted from this promotion." },
  { text: "In case of a tie, priority will be given to customers with a longer tenure. " },

  { text: "In case there is a tie in tenure, three months ARPU prior to promo month will be used to select winner." },
  { text: "MTN Staff and their spouses as well as third party agents are exempted from this promo." },

  { text: "Selected winners need to be validated internally by RA and externally by an accredited auditing firm before invitation is sent to deserving customers." },

  { text: "Prizes will be rolled over to the next highest in the rank after exhausting all efforts to reach the winner including calling their frequently called numbers for assistance without success in 48 hours. " },

  { text: "Winners duly informed of their prizes will be given a two - week notification to claim their prize or indicate interest in the prize.If the winners selected are not available to claim the prize after two weeks, such prizes will be returned to chest and added to the prizes for the next promo." },

  { text: "MTN reserves the right to disqualify a winner when it is proven that the winner used any fraudulent means to participate in the promo.Such customers will be handed over to the police to face the law." },

  { text: "Promo duration can be extended whenever MTN deems it appropriate." },

  { text: "Winner selection and rankings among partcipants who mashup on the App will be limited to only participants with ages up to 35 years." },

  { text: "A customer cannot win promo prizes under each category within the same month." },

  { text: "Although an individual can accrue points under the Mashup Group and separate points outside Mashup Group, such individual will forfeit the lesser prize reward in situations where such individuals win prizes under both groups in the same month." },

  { text: "Customers who do not perform any other activity on myMTN App apart from MoMo transactions will not qualify for winner selection and rankings.All promo participants must perform mashup activity apart from MoMo transaction on myMTN App." },

  { text: "All customers who undertake Airtime and Mobile Money reversals will be disqualified from winner selecton and rankings for the month." },

  { text: "Points accrued by promo participants remain personal customer information of partcipants and MTN will not publish such information publicly in line with data privacy and protection." },

  { text: "Winners will be notified only by MTN authorized personnel and via the number 0244 300 000." },
];

const PulseNChillTerms = () => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;
  const {
    selectedLoyaltyData,
  } = useLoyalty();

  const { promoData: { tailImage } = {} } = selectedLoyaltyData || {};

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then(anl => logEvent(anl, "screen_view", {
      firebase_screen: "PulseAndChillTerms",
      firebase_screen_class: "PulseAndChillTerms",
    }));
  }, []);
  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px 30px 15px' }}>
              <StyledText size={20} style={{ textAlign: 'center' }}>{'Terms & Conditions'}</StyledText>
              <hr style={{ marginBottom: '30px' }} />
              {
                terms && terms.map(({ text, table }, index) => {
                  const num = index + 1;
                  return (
                    <div style={{ marginBottom: '25px', }}>
                      <StyledText size={12} style={{ fontFamily: 'MTNRegular', margin: 0 }}>{num}. {text}</StyledText>
                      {table && <TermsTable {...table} />}
                    </div>
                  )
                })
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const TermsTable = ({ title, rows }) => {
  return (
    <div style={{ marginTop: '10px' }}>
      <table
        style={{
          fontFamily: 'MTNRegular',
          fontSize: '12px',
          borderCollapse: 'collapse',
          border: '1px solid #777',
        }}
      >
        <tbody>
          <tr>
            <td colspan="2" style={{ verticalAlign: 'top', padding: '10px', textAlign: 'center', border: '1px solid #777' }}>{title}</td>
          </tr>
          {rows.map(row => {
            return <tr>{row.map(rowData => <td style={{ verticalAlign: 'top', padding: '5px', border: '1px solid #777' }}>{rowData}</td>)}</tr>
          })}
        </tbody>
      </table>
    </div>
  )
}



export default PulseNChillTerms;
